import { render, staticRenderFns } from "./GuideConsultationItem.vue?vue&type=template&id=7708754d"
import script from "./GuideConsultationItem.vue?vue&type=script&lang=js"
export * from "./GuideConsultationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports